import ExactQuantity from './containers/ExactQuantity';

export default ExactQuantity;
